(function () {
  var MIN_CENTS_DEFAULT = 4999;

  function getMinCents(wrapper) {
    var min = Number(wrapper.getAttribute('data-afterpay-min-cents'));
    return min > 0 ? min : MIN_CENTS_DEFAULT;
  }

  function formatInstallment(cents) {
    var installmentCents = Math.round(Number(cents) / 4);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var moneyFormat = (document.body.getAttribute('data-money-format') || '${{amount}}').replace(/\s+/g, ' ').trim();
      return Shopify.formatMoney(installmentCents, moneyFormat);
    }
    return '$' + (installmentCents / 100).toFixed(2);
  }

  window.updateAfterpayMessaging = updateMessaging;

  function updateMessaging(wrapper, cents) {
    if (!wrapper) return;
    var amount = Number(cents) || 0;
    var eligible = amount >= getMinCents(wrapper);
    wrapper.hidden = !eligible;
    wrapper.setAttribute('data-afterpay-amount', String(amount));

    if (!eligible) return;

    var amountEl = wrapper.querySelector('[data-afterpay-installment]');
    if (amountEl) {
      amountEl.textContent = formatInstallment(amount);
    }
  }

  function wrapSelectCallback() {
    if (typeof window.selectCallback !== 'function' || window.selectCallback._afterpayWrapped) {
      return;
    }

    var original = window.selectCallback;
    var wrapped = function (variant, selector) {
      original.apply(this, arguments);
      if (!variant || !selector || !selector.product) return;

      var wrapper = document.querySelector(
        '.product-' + selector.product.id + ' [data-afterpay-messaging]'
      );
      if (wrapper) {
        updateMessaging(wrapper, variant.price);
      }
    };

    wrapped._afterpayWrapped = true;
    window.selectCallback = wrapped;
  }

  function initProduct(wrapper) {
    var section = wrapper.closest('.js-product_section') || wrapper.closest('.product-page__information');
    if (!section) return;

    var form = section.querySelector('[data-product-form]');
    if (!form) return;

    var product;
    try {
      product = JSON.parse(form.getAttribute('data-product'));
    } catch (error) {
      return;
    }

    var select = form.querySelector('[data-variants]');
    if (!select) return;

    function syncFromSelect() {
      var selectedId = Number(select.value);
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i += 1) {
        if (variants[i].id === selectedId) {
          updateMessaging(wrapper, variants[i].price);
          return;
        }
      }
    }

    select.addEventListener('change', syncFromSelect);
  }

  function syncCartMessaging(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;
    var wrappers = document.querySelectorAll(
      '[data-afterpay-messaging][data-afterpay-context="cart"], [data-afterpay-messaging][data-afterpay-context="mini-cart"]'
    );
    for (var i = 0; i < wrappers.length; i += 1) {
      updateMessaging(wrappers[i], cart.total_price);
    }
  }

  function bindModal() {
    if (window._afterpayModalBound) return;
    window._afterpayModalBound = true;

    function getModal() {
      return document.getElementById('afterpay-info-modal');
    }

    function openModal() {
      var modal = getModal();
      if (!modal) return;
      modal.hidden = false;
      document.body.classList.add('afterpay-modal-open');
    }

    function closeModal() {
      var modal = getModal();
      if (modal) modal.hidden = true;
      document.body.classList.remove('afterpay-modal-open');
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      if (target.closest('[data-afterpay-modal-open]')) {
        event.preventDefault();
        openModal();
      }
      if (target.closest('[data-afterpay-modal-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      var modal = getModal();
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function bindGlobalListeners() {
    if (window._afterpayMessagingBound) return;
    window._afterpayMessagingBound = true;

    document.addEventListener('copper:cart:updated', function (event) {
      syncCartMessaging(event.detail);
    });
  }

  function init() {
    wrapSelectCallback();
    bindGlobalListeners();
    bindModal();

    var wrappers = document.querySelectorAll('[data-afterpay-messaging]');
    for (var i = 0; i < wrappers.length; i += 1) {
      var wrapper = wrappers[i];
      if (wrapper.getAttribute('data-afterpay-bound') === 'true') continue;
      wrapper.setAttribute('data-afterpay-bound', 'true');

      if (wrapper.getAttribute('data-afterpay-context') === 'product') {
        initProduct(wrapper);
      }
    }
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  window.initAfterpayMessaging = init;

  ready(function () {
    init();

    if (window.InstantClick && typeof InstantClick.on === 'function') {
      InstantClick.on('change', init);
    }
  });
})();
